<template>
  <v-app>
    <app-header></app-header>

    <v-fade-transition hide-on-leave>
      <router-view></router-view>
    </v-fade-transition>
    
    <div id="fb-root" style="z-index: 10"></div>

    <app-footer></app-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  // metaInfo: {
  //   // if no subcomponents specify a metaInfo.title, this title will be used
  //   title: '社團法人中華服務品質發展協會',
  //   // all titles will be injected into this template
  //   titleTemplate: null,
  //   meta: [
  //     { charset: 'utf-8' },
  //     { vmid: 'description', name: 'description', content: '瞬息萬變的市場中，該如何提升服務品質，才能有所突破？中華服務品質發展協會與您共同分享如何提升企業競爭力！不論您是主管、員工或社會新鮮人，衷心期盼您的加入，共同為建置及推展國內服務品質全方位資訊分享與專業學習平台而努力！' }
  //   ]
  // },
  components: {
    'app-header': () => import('@/components/app/header'),
    'app-footer': () => import('@/components/app/footer'),
  },
  data: () => ({
    //
  }),
  watch: {
    mobile: {
      handler() {
        this.$store.commit('isMobile', this.mobile);
      },
      immediate: true
    }
  },
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return true;
        default:
          return false;
      }
    }
  },
};
</script>
